// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1K7zR","header":"MessagesList_header__2z_Wr","chat":"MessagesList_chat__PTr2N"};